import { Component, OnDestroy, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { BookingService } from '@app/listing/services/booking.service';

import {
  NotificationService,
  LogService,
  ListingService,
  DateService,
  ArrayService,
  AppSettingsService,
  UserService,
  ValueService,
  RouteHelperService,
} from '@app/services';
import { Router, Event, ActivatedRoute } from '@angular/router';
import { NavigationStart, NavigationError, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import CheckInOutSearchRequest from '@app/models/check-in-out-search-request';
import PagedResults from '@app/models/paged-results';
import { SpinnerComponent } from '../../../common-components/spinner/spinner.component';

import { CheckInEventGridComponent } from '../check-in-event-grid/check-in-event-grid.component';


/**
 * Checkin/Checkout events including the search controls and the result grid
 *
 * <check-in-events []=""  > </check-in-events>
 */
@Component({
    selector: "check-in-events",
    templateUrl: "./check-in-events.component.html",
    styleUrls: ["./check-in-events.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CheckInEventGridComponent, SpinnerComponent]
})
export class CheckInEventsComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'CheckInEventsComponent';

  public routerEventsSubscription: Subscription;


  @Input()
  public listingId: number;

  public results: PagedResults;

  public retrieving = false;

  constructor(
    private bookingService: BookingService,

    private log: LogService,
    private notify: NotificationService,
    private listingService: ListingService,
    private dateService: DateService,
    private valueService: ValueService,
    private arrayService: ArrayService,
    private appSettings: AppSettingsService,
    private userService: UserService,
    private router: Router,
    private routeHelper: RouteHelperService,
    private route: ActivatedRoute
  ) {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        //do something on start activity
      }
      if (event instanceof NavigationError) {
        // Handle error
        console.error(event.error);
      }
      if (event instanceof NavigationEnd) {
        //do something on end activity

        this.listingId = +this.routeHelper.getRouteParameter(this.route, 'id');

        this.retrieveData();
      }
    });
  }

  ngOnInit() {}

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public onRefreshDataClick() {
    console.log(`${this._componentName}.onRefreshDataClick()`);

    this.retrieveData();
  }

  /**
   * A partial search request configured by the check in events grid (sort column and sort direction)
   * @param request
   */
  public onGridDataInvalidated(request: CheckInOutSearchRequest) {
    if (request) {
      request.listingId = this.listingId;
      this.search(request);
    }
  }

  private search(request: CheckInOutSearchRequest) {
    console.log(`${this._componentName}.retrieveData()`);

    this.retrieving = true;

    this.bookingService.searchCheckInCheckOutEvents(request).subscribe(
      (results) => {
        console.log(`${this._componentName}retrieveData() - searchCheckInCheckOutEvents - subscription results=`, results);
        this.results = results as PagedResults;
        this.retrieving = false;
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
        this.retrieving = false;
      }
    );
  }

  public retrieveData() {
    console.log(`${this._componentName}.retrieveData()`);

    this.retrieving = true;

    let request = {
      listingId: this.listingId,
      sortCol: 'timestamp',
      sortDirection: 'desc',
    } as CheckInOutSearchRequest;

    this.search(request);
  }
}
